export enum Industry {
	AgricultureForestryFishing = 'AgricultureForestryFishing',
	Manufacturing = 'Manufacturing',
	Utilities = 'Utilities',
	Construction = 'Construction',
	ShopsRetail = 'ShopsRetail',
	BuyingSellingDistribution = 'BuyingSellingDistribution',
	TransportDeliveryServices = 'TransportDeliveryServices',
	WarehousingStorage = 'WarehousingStorage',
	HospitalityFoodAccommodation = 'HospitalityFoodAccommodation',
	InformationCommunication = 'InformationCommunication',
	ProfessionalBusinessServices = 'ProfessionalBusinessServices',
	FinancialServices = 'FinancialServices',
	RealEstateProperty = 'RealEstateProperty',
	ArmedForces = 'ArmedForces',
	GovernmentAndCivilService = 'GovernmentAndCivilService',
	Education = 'Education',
	HealthSocialCare = 'HealthSocialCare',
	BeautyFitnessWellbeingServices = 'BeautyFitnessWellbeingServices',
	DomesticHouseholdServices = 'DomesticHouseholdServices',
	ArtsEntertainmentLeisure = 'ArtsEntertainmentLeisure',
	CharityVoluntarySector = 'CharityVoluntarySector',
	Other = 'Other',
}
